import { useQuery } from '@tanstack/react-query';
import type { BusinessCard } from '@secretario/shared';
import { getBusinessCard } from '../../lib/api/business.js';
import './pro-seal.css';

/**
 * Cartão público de uma conta, quando ela é profissional. Quem não tem
 * "Meu negócio" não tem cartão: a consulta falha em silêncio e fica guardada.
 */
export function useBusinessCard(username: string | null | undefined): BusinessCard | null {
  const cardQ = useQuery({
    queryKey: ['business-card', username],
    queryFn: () => getBusinessCard(username!),
    enabled: !!username,
    retry: false,
    staleTime: 10 * 60_000,
  });
  return cardQ.data ?? null;
}

/** Selo de conta profissional ao lado do nome. */
export function ProSeal({ size = 16 }: { size?: number }) {
  return (
    <svg
      className="pro-seal"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Conta profissional"
    >
      <path
        className="pro-seal-body"
        d="M12 1.6l2.5 1.9 3.1-.3 1.2 2.9 2.9 1.2-.3 3.1 1.9 2.5-1.9 2.5.3 3.1-2.9 1.2-1.2 2.9-3.1-.3-2.5 1.9-2.5-1.9-3.1.3-1.2-2.9-2.9-1.2.3-3.1L1.6 12l1.9-2.5-.3-3.1 2.9-1.2 1.2-2.9 3.1.3z"
      />
      <path
        className="pro-seal-check"
        d="M7.8 12.3l2.8 2.8 5.6-5.9"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Etiqueta "Conta profissional" para cabeçalhos de perfil. */
export function ProAccountTag() {
  return (
    <span className="pro-tag">
      <ProSeal size={13} />
      Conta profissional
    </span>
  );
}
